import * as React from 'react'
import { connect } from 'react-redux'
import type { RootState, Dispatch } from '../../../app/store'
import Page from '../../layout/Page'
import Modal from '../../Modal'
import loader from '../../../images/loading.gif'
import styles from './Checkout.module.css'
import Payment from '../../Payment'
import { useParams, useLocation, useNavigate } from 'react-router-dom'

interface CheckoutT {
  cartId: string | null,
  token: string | null,
  paymentStatus: string | null,
  getPaymentStatus: (payload: { storeId: string }) => Promise<void>,
  verifyPaymentStatus: (payload: { storeId: string, orderId: string }) => Promise<void>,
  setPaymentStatus: any,
  createOrder: (payload?: any) => Promise<void>,
  currentOrderId: any
  paymentUrl: any,
  fetchCart: () => Promise<void>,
  location: any
}

// Payment status
// Unknown = 0,
// Initialized = 100,
// Completed = 200,
// Failed = 300,
// Cancelled = 400


function Checkout ({ cartId, paymentStatus, verifyPaymentStatus, setPaymentStatus, createOrder, paymentUrl, fetchCart }: CheckoutT) {
  const STORAGE_NAME = 'payexref';
  const { storeId, orderId } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = React.useState(false)
  const [paymentError, setPaymentError] = React.useState(false);
  let decodedRef = paymentUrl


  if (!decodedRef) {
    decodedRef = localStorage.getItem(STORAGE_NAME);
  }


  React.useEffect(() => {
    const getCart = async () => {
      try {
        setLoading(true)
        await fetchCart()
        localStorage?.removeItem('payexref');
        createOrder()
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }

    !localStorage?.getItem('payexref') && !cartId && getCart()
  }, [cartId, fetchCart, createOrder])

  React.useEffect(() => {
    if (!storeId || !orderId || !paymentStatus) return

    const paymentCompleted = paymentStatus.toLowerCase() === 'completed' || 
                            paymentStatus.toLowerCase() === 'awaitingactivity'

    if (paymentCompleted) {
      navigate(`/butik/${storeId}/${orderId}/tack`)
    }
  }, [paymentStatus, storeId, orderId])

  React.useEffect(() => {
    if (!storeId || !orderId) return

    const searchParams = new URLSearchParams(location.search)
    const swishUserToken = searchParams.get('swp_ut')

    // If we have the Swish return query parameter, verify payment status
    if (swishUserToken && !paymentStatus) {
      verifyPaymentStatus({ storeId, orderId })
    }
  }, [location.search, storeId, orderId, paymentStatus])

  function retryPayment () {
    setPaymentError(false)
    setPaymentStatus(null)
    createOrder()
  }

  return (
    <Page withCancelButton={true}>
      <section className={styles.checkout}>
        <div className={styles.content}>
          <h1 className={styles.heading}>Betalning</h1>
          {loading === true ? (
            <div className={styles.loader}>
              <img src={loader} alt="laddningsikon" />
            </div>
          ) : (
            <>
              <Payment handleError={setPaymentError} paymentHref={decodedRef} orderId={orderId} storeId={storeId} />
            </>
          )}

        </div>
      </section>
      <Modal maxWidth="850px" active={paymentError} onConfirm={() => null} onCancel={() => retryPayment()}>
        <div className={styles.modalContent}>
          <h2 className={styles.modalHeading}>Betalningen misslyckades</h2>
          <button onClick={() => retryPayment()} className={styles.modalButton} type="button">Försök igen</button>
        </div>
      </Modal>
    </Page>
  )
}

function mapState (state: RootState) {
  return {
    token: state.order.swishToken,
    cartId: state.cart.cartId,
    paymentStatus: state.order.paymentStatus,
    currentOrderId: state.order.currentOrderId,
    paymentUrl: state.order.paymentUrl
  }
}
function mapDispatch (dispatch: Dispatch) {
  return {
    getPaymentStatus: dispatch.order.getPaymentStatus,
    verifyPaymentStatus: dispatch.order.verifyPaymentStatus,
    createOrder: dispatch.order.createOrder,
    setPaymentStatus: dispatch.order.setPaymentStatus,
    fetchCart: dispatch.cart.fetchCart
  };
}

export default connect(mapState, mapDispatch)(Checkout)